import { QuoteChargeListingEntity, QuoteChargeType } from "../types";
import { generateEquipmentName } from "../../equipment";

export function generateAvailableItemsForAttach(rows: QuoteChargeListingEntity[]) {
  return rows.reduce<Array<{ id: string; description: string; rowIndex: number }>>(
    (acc, { type, equipment }, index) => {
      if (type === QuoteChargeType.Equipment && equipment) {
        acc.push({
          rowIndex: index,
          id: equipment.equipmentId,
          description: generateEquipmentName(equipment),
        });
      }

      return acc;
    },
    []
  );
}
